export default __webpack_public_path__ + "static/media/cot2Cover.67bd8667.jpg";